import sentryIgnoreErrors from '@skillbox/sentry-ignore-errors'
import { init, captureException, browserTracingIntegration } from '@sentry/browser';

const TIMEOUT_ERROR_NAME = 'RequestTimeoutError';
// Сообщение RequestTimeoutError: `Request timeout 5000ms: <url>`. Слева допускаем
// только начало текста и `RequestTimeoutError: `, справа обрываем URL на скобке
// и кавычке: иначе fingerprint таймаута достаётся чужой ошибке с этой фразой,
// а сам URL склеивается с пунктуацией обёртки
const TIMEOUT_URL_RE = /(?:^|RequestTimeoutError: )Request timeout \d+ms: ([^\s)'"]+)/;

// Пять мест логируют таймаут строкой, а не объектом Error: гео, портфолио v1 и v3,
// программа курса и саджесты в @skillbox/front-box
const getEventText = (event, hint) => {
  const original = hint?.originalException;

  return [
    typeof original === 'string' ? original : original?.message,
    event.message,
    ...(event.exception?.values ?? []).map(({ value }) => value)
  ].filter(Boolean).join(' ');
};

const isTimeoutEvent = (event, hint) => hint?.originalException?.name === TIMEOUT_ERROR_NAME
  || TIMEOUT_URL_RE.test(getEventText(event, hint));

// URL содержит id лендинга, спикера, блока — без нормализации fingerprint
// разносит таймауты одного эндпоинта по тысячам отдельных issue
const getUrlPattern = (url) => url.split('?')[0].replace(/\/\d+/g, '/:id');

// У события, залогированного строкой, нет поля url, и без разбора текста
// все такие таймауты схлопнулись бы в один общий issue
const getTimeoutUrl = (event, hint) => hint?.originalException?.url
  ?? TIMEOUT_URL_RE.exec(getEventText(event, hint))?.[1]
  ?? '';

export const sentryInit = () => {
  /*eslint-disable */
  if (sentryDsn) {
    init({
      dsn: sentryDsn,
      environment: environment,
      ignoreErrors: sentryIgnoreErrors.errors,
      integrations: [
        browserTracingIntegration({
          tracePropagationTargets: [/^(https:\/\/)(.*)(skillbox.ru\/api\/|selcdn.ru).*/]
        })
      ],
      beforeSend: (event, hint) => {
        // Таймауты редки и уходят в Sentry целиком: семплирование могло стереть
        // всю серию за инцидент, а level ниже error вывел бы их из-под алертов.
        // Группируем по эндпоинту, чтобы одна проблема не расползалась по issue
        if (isTimeoutEvent(event, hint)) {
          event.fingerprint = [TIMEOUT_ERROR_NAME, getUrlPattern(getTimeoutUrl(event, hint))];
        }

        return event;
      },
      tracesSampleRate: 0.2
    });
  }

  window.Sentry = {
    captureException: (error, extra) => {
      captureException(error, extra);
    },
  };
  /*eslint-enable */
};
